import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { api } from '@/api/client';

export const notificationKeys = {
  all: () => ['notifications'] as const,
  unreadCount: () => ['notifications-unread'] as const,
};

export function useNotifications() {
  return useQuery({
    queryKey: notificationKeys.all(),
    queryFn: () => api.listNotifications(),
    staleTime: 30_000,
  });
}

export function useUnreadCount() {
  return useQuery({
    queryKey: notificationKeys.unreadCount(),
    queryFn: () => api.getUnreadCount(),
    staleTime: 30_000,
    // Обновляем каждые 60 секунд, чтобы бейдж был свежим (потом заменим на WebSocket)
    refetchInterval: 60_000,
  });
}

export function useMarkAllRead() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: () => api.markAllNotificationsRead(),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: notificationKeys.all() });
      qc.invalidateQueries({ queryKey: notificationKeys.unreadCount() });
    },
  });
}

export function useMarkRead() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => api.markNotificationRead(id),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: notificationKeys.all() });
      qc.invalidateQueries({ queryKey: notificationKeys.unreadCount() });
    },
  });
}